import { render } from "./IconFeatureGrid.vue?vue&type=template&id=456d58f0"
import script from "./IconFeatureGrid.vue?vue&type=script&lang=js"
export * from "./IconFeatureGrid.vue?vue&type=script&lang=js"

import "./IconFeatureGrid.vue?vue&type=style&index=0&id=456d58f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__